import { SPage } from "src/components/spage";
import { ListTable } from "./table";
import { usePaginator } from "src/hooks/use-paginator";

interface IProps {}
export const ModulesPage = ({}: IProps) => {
  const pagination = usePaginator("__modules__", "api/Modules/List");
  return (
    <SPage
      createOptions={{ enable: true }}
      searchOptions={{ enabled: true, ...pagination }}
      title={"Modules"}
    >
      <ListTable {...pagination} />
    </SPage>
  );
};
